import autoTable from 'jspdf-autotable';
import title from '../../../helpers/title';

const errorMessages = (doc, data, info, docStyles) => {
  const { Response } = data;

  title(
    doc,
    docStyles,
    'Error Message(s)',
    docStyles.headers.primary,
    docStyles.separation,
    true // PRIMARY HEADER STYLES
  );

  const columnsBody = [
    { title: '', dataKey: 'col1' },
    {
      title: '',
      dataKey: 'col2',
    },
  ];
  const rowsBody = [];

  // DATA SOURCE RESPONSE
  let residential = Response.serviceResponses['Germany Residential'];
  let utility = Response.serviceResponses['Germany Utility'];
  let phone = Response.serviceResponses['Germany Phone'];
  let watchlistAML = Response.serviceResponses['Watchlist AML'];

  // GERMANy RESIDENTIAL ERRORS
  if (residential) {
    let status;
    if (residential.status === 3) {
      status = residential.errorMessage
        ? residential.errorMessage
        : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'Germany Residential',
      col2: status,
    });
  } else {
    residential = { verifications: {}, returnedData: {} };
  }

  // GERMANY UTILITY ERRORS
  if (utility) {
    let status;
    if (utility.status === 3) {
      status = utility.errorMessage ? utility.errorMessage : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'Germany Utility',
      col2: status,
    });
  } else {
    utility = { verifications: {}, returnedData: {} };
  }

  if (phone) {
    let status;
    if (phone.status === 3) {
      status = phone.errorMessage ? phone.errorMessage : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'Germany Phone',
      col2: status,
    });
  } else {
    phone = { verifications: {}, returnedData: {} };
  }

  if (watchlistAML) {
    let status;
    if (watchlistAML.status === 3) {
      status = watchlistAML.errorMessage
        ? watchlistAML.errorMessage
        : 'Error at Data Source';
    } else {
      status = 'N/A';
    }
    rowsBody.push({
      col1: 'Global Watchlist AML',
      col2: status,
    });
  } else {
    watchlistAML = { verifications: {}, returnedData: {} };
  }

  const finalY = (doc.lastAutoTable.finalY || 40) + docStyles.tableYFromTitle;
  autoTable(doc, {
    columnsBody,
    rowsBody,
    didParseCell: (data) => {
      const { cell, column } = data;
      cell.styles.fillColor = [255, 255, 255];
      if (column.raw.dataKey === 'col1') {
        cell.styles.textColor = docStyles.color;
      }
    },
    showHead: 'never',
    styles: {
      textColor: docStyles.colorText,
      font: docStyles.fontFamily.time,
      ...docStyles.tableStyles,
    },
    columnStyles: {
      col1: {
        font: docStyles.fontFamily.time,
        textColor: docStyles.colorText,
        cellWidth: docStyles.cellWidth,
      },
      col2: {
        font: docStyles.fontFamily.time,
        textColor: docStyles.colorText,
      },
    },
    // margin: { bottom: 100 }, // PREVENTS OVERLAP WITH FOOTER
    startY: finalY,
  });
};

export default errorMessages;
